import type { AxiosError } from 'axios';
import type { SWRConfiguration } from 'swr';
import useSWR from 'swr';

import type { VoteHistoryPayload } from 'src/types/proposals';
import { get } from 'src/utils/axios';

type FetchProps = {
  fetchUrl: string;
};

type UseVoteHistoryProps = {
  voterAddress?: string;
};

export function useVoteHistorySWR({ voterAddress }: UseVoteHistoryProps, config?: SWRConfiguration) {
  const requestURL = `https://front.api.mintscan.io/v1/dydx/account/${voterAddress || ''}/votes`;

  const fetcher = async ({ fetchUrl }: FetchProps) => get<VoteHistoryPayload>(fetchUrl);

  const { data, error, mutate } = useSWR<VoteHistoryPayload, AxiosError>({ fetchUrl: requestURL }, fetcher, {
    dedupingInterval: 14000,
    refreshInterval: 15000,
    errorRetryCount: 5,
    isPaused: () => !requestURL,
    ...config,
  });

  return {
    data,
    error,
    mutate,
  };
}
